/**
 * UI State Models
 * 
 * Defines the state shape and types for UI-related state management.
 * This includes cross-cutting UI concerns like sidenav, modals, toasts, etc.
 */

/**
 * Sidenav State
 */
export interface SidenavState {
  isOpen: boolean;
}

/**
 * Main UI State Interface
 */
export interface UiState {
  // Sidenav state
  sidenav: SidenavState;
  
  // Future UI state can be added here:
  // safariGuide: SafariGuideState;
  // network: NetworkState;
  // modals: ModalState;
}

/**
 * Initial UI State
 */
export const initialUiState: UiState = {
  sidenav: {
    isOpen: false
  }
};
